// extracted by mini-css-extract-plugin
export default {"textarea":"mJf5Rt9nG9ob5aXufHeE"};